import { render, staticRenderFns } from "./MyProjectsView.vue?vue&type=template&id=41c987f8&"
import script from "./MyProjectsView.vue?vue&type=script&lang=js&"
export * from "./MyProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports